import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { Session } from "@supabase/supabase-js";

interface IndexProps {
  session: Session | null;
}

const Index = ({ session }: IndexProps) => {
  return (
    <div className="min-h-screen bg-skuhub-navy text-white">
      <Navigation session={session} />
      <Hero />
      <Features />
    </div>
  );
};

export default Index;